import type { ReactElement } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

interface Props {
  children: ReactElement
}

export default function ProtectedRoute({ children }: Props) {
  const { user, loading: isLoading } = useAuth()
  const isAuth = !!user
  const navigate = useNavigate()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="flex flex-col items-center gap-3">
          <div className="h-8 w-8 rounded-full border-2 border-gray-200 border-t-black dark:border-gray-700 dark:border-t-white animate-spin" />
          <p className="text-sm text-gray-400 dark:text-gray-500">Loading…</p>
        </div>
      </div>
    )
  }

  if (!isAuth) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
        <h2 className="text-2xl font-medium text-gray-800 dark:text-gray-200 mb-3">
          Access restricted
        </h2>
        <p className="text-gray-500 dark:text-gray-400 mb-6 max-w-sm">
          You need to sign in to access this section.
        </p>
        <button
          onClick={() => navigate('/login')}
          className="px-6 py-2.5 rounded-xl bg-black dark:bg-white text-white dark:text-black text-sm font-medium hover:opacity-90 transition"
        >
          Sign in
        </button>
      </div>
    )
  }

  return children
}
